import React, { ReactNode } from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';

interface PageContainerProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({ title, children, actions }) => {
  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 3 
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          {title}
        </Typography>
        {actions && (
          <Box>
            {actions}
          </Box>
        )}
      </Box>
      <Divider sx={{ mb: 3 }} />
      {children}
    </Box>
  );
};

export default PageContainer;
